import { AddressMapContextProvider } from 'components/common/AdressMap'
import { ClientPropertyInformationContent } from '../../ClientPropertyInformation'
import { FC } from 'react'

export const ClientPropertyInformationPage: FC = () => {

  return (
    <AddressMapContextProvider>
      <ClientPropertyInformationContent />
    </AddressMapContextProvider>
  )
}
